/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Since_Half_YearInputs */

const en_us2_profile_editors_pain_since_half_year = /** @type {(inputs: Profile_Editors_Pain_Since_Half_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More than 6 months ago`)
};

const pt_br2_profile_editors_pain_since_half_year = /** @type {(inputs: Profile_Editors_Pain_Since_Half_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há mais de 6 meses`)
};

const es_419_profile_editors_pain_since_half_year = /** @type {(inputs: Profile_Editors_Pain_Since_Half_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hace más de 6 meses`)
};

const pt_pt2_profile_editors_pain_since_half_year = /** @type {(inputs: Profile_Editors_Pain_Since_Half_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há mais de 6 meses`)
};

const fr_fr2_profile_editors_pain_since_half_year = /** @type {(inputs: Profile_Editors_Pain_Since_Half_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de 6 mois`)
};

const de_de2_profile_editors_pain_since_half_year = /** @type {(inputs: Profile_Editors_Pain_Since_Half_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seit über 6 Monaten`)
};

const it_it2_profile_editors_pain_since_half_year = /** @type {(inputs: Profile_Editors_Pain_Since_Half_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da più di 6 mesi`)
};

/**
* | output |
* | --- |
* | "More than 6 months ago" |
*
* @param {Profile_Editors_Pain_Since_Half_YearInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_since_half_year = /** @type {((inputs?: Profile_Editors_Pain_Since_Half_YearInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Since_Half_YearInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_since_half_year(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_since_half_year(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_since_half_year(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_since_half_year(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_since_half_year(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_since_half_year(inputs)
	return en_us2_profile_editors_pain_since_half_year(inputs)
});
export { profile_editors_pain_since_half_year as "profile-editors.pain_since_half_year" }